import { IconProps } from './iconTypes';

export const Add = ({ color, ...props }: IconProps): JSX.Element => (
    <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
        <g stroke={color} strokeWidth="2" fill="none" fillRule="evenodd">
            <path d="M0 9h18m-9 9V0" />
        </g>
    </svg>
);
